
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojaipurtaxiservice() {



    const cardData =
    {
        keyword: 'Pune to Jaipur Taxi Service ',
        heading: 'Platinum24 Cabs: Pune to Jaipur Taxi Service',
        headingDescription: ' Platinum24 Cabs offers trusted Pune to Jaipur taxi service, perfect for tourists, families, and corporate travelers heading to Rajasthan’s capital. Whether you’re planning to explore the iconic Amer Fort, Hawa Mahal, and City Palace, or traveling for business meetings and family events, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe ride. With professional chauffeurs, punctual pickups, and transparent pricing, we make your long-distance journey hassle-free. From one-way trips to customized return packages, Platinum24 Cabs guarantees a smooth and memorable Pune to Jaipur travel experience.',

        top: 'Top Places to Visit in Jaipur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Amber Fort",
    "description": "Amber Fort, built in the 16th century by Raja Man Singh, is Jaipur’s most stunning fort-palace. Overlooking Maota Lake, its courtyards, Sheesh Mahal (Mirror Palace), and Diwan-e-Aam showcase Rajput architecture. Visitors enjoy elephant rides and evening light-and-sound shows. The fort’s blend of Hindu and Mughal styles is mesmerizing. Amber Fort is Jaipur’s crown jewel of heritage."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, or the Palace of Winds, is Jaipur’s most iconic landmark. Built in 1799, its honeycomb façade with 953 jharokhas allowed royal women to observe city life unseen. The pink sandstone monument glows beautifully in the morning sun. Visitors climb up for views of City Palace and Jantar Mantar. Hawa Mahal is Jaipur’s symbol of elegance and history."
  },
  {
    "title": "City Palace",
    "description": "City Palace, built by Maharaja Sawai Jai Singh II, is a grand complex of palaces, courtyards, and museums. It still houses Jaipur’s royal family. Attractions include Mubarak Mahal, Chandra Mahal, and the armory museum. The palace showcases Rajput, Mughal, and European influences. Tourists admire its architecture and royal artifacts. City Palace is Jaipur’s regal heart."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar, a UNESCO World Heritage Site, is an astronomical observatory built in 1734. It houses the world’s largest stone sundial and several instruments used for celestial calculations. The site reflects Jaipur’s scientific heritage. Visitors marvel at its precision and design. It is a blend of astronomy, science, and architecture. Jantar Mantar is Jaipur’s scientific wonder."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort, perched on the Aravalli hills, offers panoramic views of Jaipur city. Built in 1734 by Maharaja Sawai Jai Singh II, it served as a retreat for the royals. The fort’s Madhavendra Bhawan, with interconnected suites, is a highlight. Sunset views here are breathtaking. Today, cafes and cultural shows add to the experience. Nahargarh Fort is Jaipur’s scenic hilltop retreat."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort, built in 1726, is known as the Fort of Victory. It houses the world’s largest cannon on wheels, Jaivana. The fort was built to protect Amber Fort and has strong walls and watchtowers. Underground passages connect it to Amber. Visitors explore its palaces, granaries, and armories. Jaigarh Fort is Jaipur’s stronghold of valor and defense."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum, built in 1887, is Rajasthan’s oldest museum. Its Indo-Saracenic architecture and sprawling gardens attract tourists. Exhibits include paintings, sculptures, carpets, arms, and even an Egyptian mummy. The museum glows beautifully when lit at night. History lovers and students find it fascinating. Albert Hall is Jaipur’s treasure house of art and history."
  },
  {
    "title": "Jal Mahal",
    "description": "Jal Mahal, or Water Palace, is a stunning palace in the middle of Man Sagar Lake. Built in Rajput and Mughal styles, it looks enchanting during sunrise and sunset. Though entry inside is restricted, boat rides offer close views. Migratory birds often flock to the lake. It is a favorite for photography and sightseeing. Jal Mahal is Jaipur’s floating jewel."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, built of white marble, is dedicated to Lord Vishnu and Goddess Lakshmi. Located at the base of Moti Dungri hill, it glows beautifully at night. The temple features carvings of gods, saints, and philosophers from different faiths. Its peaceful ambiance attracts both devotees and tourists. Festivals are celebrated with grandeur here. Birla Mandir is Jaipur’s modern spiritual landmark."
  },
  {
    "title": "Chokhi Dhani",
    "description": "Chokhi Dhani is a cultural village resort showcasing Rajasthan’s traditions. Visitors enjoy folk dances, puppet shows, camel rides, and traditional Rajasthani thalis. It recreates the rural lifestyle with vibrant décor. Families and tourists love its immersive cultural experience. It is especially popular in the evenings. Chokhi Dhani is Jaipur’s living museum of culture."
  }
],


     "services": [
    {
      "name": "Pune to Jaipur Taxi",
      "description": "Experience a comfortable and safe journey from Pune to Jaipur with our trusted Pune to Jaipur Taxi service. Ideal for business travelers, tourists, and families alike, our service offers well-maintained vehicles driven by professional drivers who know the best routes and travel conditions. Enjoy a hassle-free booking process, flexible pickup times, and personalized travel options that cater to your specific needs. We prioritize your comfort, safety, and timely arrival, ensuring that your long-distance trip across states is smooth and stress-free."
    },
    {
      "name": "Pune to Jaipur Cab Booking",
      "description": "Booking a cab from Pune to Jaipur is simple and convenient with our online platform and customer support team. Choose your preferred vehicle type—from economical sedans to spacious SUVs—and book your journey at the click of a button. We provide instant confirmations, clear pricing, and customizable travel plans, whether it’s a one-way trip or a round journey. Our team is available 24/7 to assist with any special requests or last-minute changes, ensuring your Pune to Jaipur travel plans are seamless and worry-free."
    },
    {
      "name": "Book Taxi from Pune to Jaipur",
      "description": "Our taxi booking service from Pune to Jaipur offers the ultimate convenience and reliability for travelers planning their next trip. Whether it’s a personal vacation, a corporate assignment, or a family event, our wide fleet of vehicles and experienced drivers ensure a comfortable ride tailored to your needs. Benefit from transparent pricing, timely pickups, and personalized service that guarantees a pleasant journey. With various payment options and easy cancellations, booking your Pune to Jaipur taxi has never been easier."
    },
    {
      "name": "Pune to Jaipur One Way Cab",
      "description": "Opt for our Pune to Jaipur One Way Cab service for budget-friendly and flexible travel without compromising on comfort. Perfect for travelers who want a hassle-free point-to-point transfer, our one-way cab service ensures fixed fares, no hidden charges, and a smooth ride. Whether you're heading to Jaipur for business or leisure, our reliable vehicles and professional drivers make your long-distance journey enjoyable and efficient."
    },
    {
      "name": "Pune to Jaipur Taxi Fare",
      "description": "We offer transparent and competitive Pune to Jaipur Taxi Fare packages designed to fit various budgets and travel preferences. Our fare structure includes all applicable taxes, tolls, and driver charges, ensuring no hidden costs or surprises. Special discounts and seasonal offers are available for frequent travelers and early bookings. Our upfront pricing policy helps you plan your trip with confidence, making your Pune to Jaipur travel affordable without compromising on quality or service."
    },
    {
      "name": "Jaipur to Pune Cab",
      "description": "Our Jaipur to Pune Cab service provides a safe and comfortable return journey with professional drivers and well-maintained vehicles. Whether you're concluding a business trip, holiday, or family visit, our Jaipur to Pune cabs offer punctual pickups, clean vehicles, and a smooth ride back to Pune. Easily book online or through customer support, with flexible schedules to match your travel plans and ensure a stress-free experience."
    },
    {
      "name": "Pune to Jaipur Car Hire",
      "description": "For travelers seeking flexibility and independence, our Pune to Jaipur Car Hire service offers self-drive and chauffeur-driven options with a diverse fleet of vehicles. Choose from fuel-efficient sedans, spacious SUVs, or luxury cars to suit your travel style and group size. Our cars are regularly maintained and equipped with modern amenities, providing a comfortable and safe journey across the state borders. Transparent pricing, easy booking, and excellent customer service complete the experience."
    },
    {
      "name": "Pune to Jaipur Outstation Cab",
      "description": "Our Pune to Jaipur Outstation Cab service caters to long-distance travelers who require dependable and comfortable transportation. Perfect for family vacations, business trips, or group tours, our vehicles are spacious, sanitized, and driven by experienced professionals well-versed in highway routes. Enjoy amenities like air conditioning, ample luggage space, and flexible booking options, all backed by our commitment to customer satisfaction and timely service."
    },
    {
      "name": "Affordable Pune to Jaipur Taxi",
      "description": "Travel smart with our Affordable Pune to Jaipur Taxi service that combines cost-effectiveness with quality. Ideal for budget-conscious travelers such as students, professionals, and small families, this service offers economical fares without sacrificing comfort or safety. Our fleet includes fuel-efficient vehicles maintained to the highest standards, ensuring a smooth and enjoyable ride. Take advantage of special deals, transparent pricing, and reliable service for your next trip to Jaipur."
    },
    {
      "name": "Pune to Jaipur Sedan and SUV Service",
      "description": "Choose from a range of sedans and SUVs with our Pune to Jaipur Sedan and SUV Service, tailored to meet the diverse needs of travelers. Whether you prefer a compact sedan for solo or couple travel or a spacious SUV for family and group trips, our vehicles come equipped with modern amenities for a comfortable ride. Professional drivers ensure a safe journey with timely pickups and efficient route management. This service offers a perfect blend of style, comfort, and reliability for your Pune to Jaipur travel."
    }
  ],
  "tableData": [
    ["Pune to Jaipur Taxi", "Pune to Jaipur Cab Booking"],
    ["Book Taxi from Pune to Jaipur", "Pune to Jaipur One Way Cab"],
    ["Pune to Jaipur Taxi Fare", "Jaipur to Pune Cab"],
    ["Pune to Jaipur Car Hire", "Pune to Jaipur Outstation Cab"],
    ["Affordable Pune to Jaipur Taxi", "Pune to Jaipur Sedan and SUV Service"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Jaipur Taxi Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable taxi services from Pune to Jaipur, ensuring a hassle-free and pleasant journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Your Travel Needs",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers tailored to your group size and preferences for Pune to Jaipur trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment during your Pune to Jaipur journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Jaipur Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Jaipur to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including fuel, tolls, and driver allowances for a hassle-free Pune to Jaipur taxi experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Jaipur taxi bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Journey",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Jaipur travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Jaipur taxi quickly and securely via our website or app with immediate confirmation."
  }
]































    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Jaipur taxi services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable taxi services from Pune to Jaipur with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a taxi from Pune to Jaipur?',
        answer: 'You can book your taxi easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Jaipur travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way taxi service available from Pune to Jaipur?',
        answer: 'Yes, both one-way and round-trip taxi services are available for Pune to Jaipur travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Jaipur long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Jaipur route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Jaipur?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Jaipur taxis?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Jaipur taxi service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Jaipur taxi bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Jaipur taxi bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Jaipur taxi service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Mehta',
        feedback: 'The Pune to Jaipur taxi service was punctual and comfortable. Highly recommend Platinum24 Cabs.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Sharma',
        feedback: 'Professional drivers and excellent customer service made my Pune to Jaipur trip memorable.',
        rating: 5,
    },
];



















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const puneToJaipurTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jaipur Taxi Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jaipur-taxi.jpg",
  "description": "Book Pune to Jaipur Taxi Service with Platinum24 Cabs. Reliable, affordable, and comfortable cabs including sedan and SUV options. Perfect for one-way trips, outstation travel, and car hire with professional drivers and 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jaipur-taxi-service"
  }
};






    return (
        <div>



<Helmet>
  <title>Pune to Jaipur Taxi Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jaipur Taxi Service with Platinum24 Cabs. Reliable, affordable, and comfortable cabs including sedan and SUV options. Perfect for one-way trips, outstation travel, and car hire with professional drivers and 24/7 availability."
  />
  <meta
    name="keywords"
    content="Pune to Jaipur Taxi, Pune to Jaipur Cab Booking, Book Taxi from Pune to Jaipur, Pune to Jaipur One Way Cab, Pune to Jaipur Taxi Fare, Jaipur to Pune Cab, Pune to Jaipur Car Hire, Pune to Jaipur Outstation Cab, Affordable Pune to Jaipur Taxi, Pune to Jaipur Sedan and SUV Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJaipurTaxiSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/116.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojaipurtaxiservice;